import React, { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from './cn';

/**
 * Button — design system (SKILL + SKILL2).
 * Dùng lại các class .btn / .btn-* trong index.css (gradient + glint + focus ring).
 *
 * Props:
 *  - variant: 'primary' | 'secondary' | 'ghost' | 'danger' | 'success' | 'warning'
 *  - size: 'xs' | 'sm' | 'base' | 'lg'
 *  - loading: hiện spinner + disable
 *  - leftIcon / rightIcon: component icon (lucide), vd leftIcon={Plus}
 *  - fullWidth, as (render tag khác, vd 'a')
 */
const VARIANT_CLASS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  danger: 'btn-danger',
  success: 'btn-success',
  warning: 'btn-warning',
};

const SIZE_CLASS = {
  xs: 'btn-xs',
  sm: 'btn-sm',
  base: '',
  lg: 'btn-lg',
};

export const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'base',
    className,
    children,
    loading = false,
    disabled = false,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    fullWidth = false,
    type = 'button',
    as: Tag = 'button',
    ...props
  },
  ref
) {
  const isDisabled = disabled || loading;
  const iconSize = size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';
  return (
    <Tag
      ref={ref}
      type={Tag === 'button' ? type : undefined}
      disabled={Tag === 'button' ? isDisabled : undefined}
      aria-disabled={isDisabled || undefined}
      aria-busy={loading || undefined}
      className={cn(
        'btn',
        VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
        SIZE_CLASS[size] || '',
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      {loading ? (
        <Loader2 className={cn(iconSize, 'animate-spin')} aria-hidden="true" />
      ) : LeftIcon ? (
        <LeftIcon className={iconSize} aria-hidden="true" />
      ) : null}
      {children}
      {!loading && RightIcon ? <RightIcon className={iconSize} aria-hidden="true" /> : null}
    </Tag>
  );
});

export default Button;
